import { CopyToClipboard } from "react-copy-to-clipboard";
import styled from "styled-components";
import { cn } from "utils/cn";
import { forwardRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useApp } from "../../contexts";
import * as Notification from "../../Notification";
import { CopyIcon } from "../Icons/CopyIcon";

const CopyValue = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  cursor: pointer;
  position: relative;

  &:hover {
    opacity: 0.9;
  }

  & b {
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    color: #000000;
    margin-right: 12px;
    @media screen and (max-width: 1024px) {
      & {
        font-size: 14px;
      }
    }
  }
`;
const CopyValueIcon = styled.div`
  position: relative;  
`;

export const Copy = forwardRef(({
  isShowText = true,
  icon = null,
  splitFont = 25,
  splitEnd = 5,
  numDot = 5,
  splitFontLg = 36,
  prefix = "",
  textCss='',
  className = '',
  ...props
}, ref) => {
  let text = props?.text || "";
  const [copied, setCopied] = useState(false);
  const { T } = useApp();
  useEffect(() => {
    let timer;
    if (copied) {
      timer = setTimeout(() => {
        setCopied(false);
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);

  const splitText = () => {
    let item = text;
    if (item.length >= splitFont + 10) {
      item = item.substring(0, splitFont);
      for (let i = 0; i < numDot; i++) {
        item += ".";
      }
      item += text.substring(text.length - splitEnd, text.length);
    }
    return item;
  };
  const splitTextLg = () => {
    let item = text;
    if (item.length >= splitFontLg + 5) {
      item = item.substring(0, splitFontLg);
      for (let i = 0; i < numDot; i++) {
        item += ".";
      }
      item += text.substring(text.length - splitEnd, text.length);
    }

    return item;
  };

  return (
    <CopyValue className={cn("flex justify-between w-full copy", className)} onClick={e => e.stopPropagation()}>
      {isShowText && (
        <b style={props?.textStyle || {}} className={textCss} onClick={() => props?.textAction?.()}>
          {prefix}{window.innerWidth <= 500 || props.cutText ? splitText(text) : splitTextLg(text)}
        </b>
      )}
      <CopyToClipboard
        onCopy={() => {
          // setCopied(true);
          Notification.success(T("Copied"))
        }}
        text={text}
      >
        <CopyValueIcon className="copy" ref={ref}>
          {icon ? icon : <CopyIcon />}
          {/* {copied ? <Copied>{}</Copied> : null} */}
        </CopyValueIcon>
      </CopyToClipboard>
    </CopyValue>
  )
});

Copy.propTypes = {
  isShowText: PropTypes.bool,
  icon: PropTypes.node,
  splitFont: PropTypes.number,
  splitEnd: PropTypes.number,
  numDot: PropTypes.number,
  splitFontLg: PropTypes.number,
  prefix: PropTypes.string,
  textCss: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  textStyle: PropTypes.object,
  textAction: PropTypes.func,
  cutText: PropTypes.bool
};
